<div class="production-db-content" dir="{{languageDir}}">
    <div class="content-top-box">
      <ul class="breadcrumb">
        <ul class="breadcrumb">
          <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
            <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
              (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{lang.getTransalatedValue(breadcrumItem.text)}}</a>
          </li>
        </ul>
      </ul>
      <div class="title-row-flex-both-end">
        <h1 class="main-title">{{langObj ? langObj?.KPITarget : ('KPITarget' | translate)}}</h1>
      </div>
    </div>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
    <form [formGroup]="KpiForm">
      <div class="content-top-row content-top-row-order-processing">
        <!-- GROUP -->
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <!-- <mat-label>Status</mat-label> -->
          <mat-select formControlName="UserGroup1" (selectionChange)="onChangeGroup($event)" placeholder="{{langObj ? langObj?.Group : ('Group' | translate)}}"
            panelClass="testClass" name="Status">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'EG_Desc'" [array]="GroupList"
              (filteredReturn)="filteredGroups = $event"></mat-select-filter>
            <mat-option *ngFor="let group of filteredGroups" [value]="group.EG_Id">
              {{group.EG_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="UserPlant1"  placeholder="{{langObj ? langObj?.Plant : ('Plant' | translate)}}" (selectionChange)="onChangePlant();"
            panelClass="testClass" name="Status">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'PT_Desc'" [array]="PlantList1"
              (filteredReturn)="filteredPlants = $event"></mat-select-filter>
            <mat-option *ngFor="let plant of filteredPlants" [value]="plant.PT_Id">
              {{plant.PT_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="inputField">
            <nz-date-picker class="calender-input" id="year" formControlName="year"
            nzMode="year" [nzInputReadOnly]="true"></nz-date-picker>
            <span class="floating-text">{{langObj ? langObj?.Selectyear : ('Selectyear' | translate)}}</span>
          </div>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-select formControlName="frequency"  placeholder="{{langObj ? langObj?.Frequency : ('Frequency' | translate)}}"
              panelClass="testClass" name="Status">
              <mat-select-filter [placeholder]="'Search'" [displayMember]="'name'" [array]="frequencyList"
                (filteredReturn)="filteredFrequency = $event"></mat-select-filter>
                <mat-option  value=0>
                 ALL
                </mat-option>
              <mat-option *ngFor="let fre of filteredFrequency" [value]="fre.frequencyId">
                {{fre.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="btn-position">
            <button type="submit" class="icon-btn" matTooltipClass="custom-tooltip" matTooltip="Apply Filter"
              (click)="onSubmit()" tooltipPosition="top">
              <img src="assets/images/search.png" alt="" width="20px" height="20px">
            </button>
          </div>
      </div>
    </form>
    <!-- list -->
    <section>
      <div class="example-button-row">
        <button type="button" class="btn btn-success" (click)="csvExport()" style="margin-top: 30px;"><img
            src="assets/images/csv-file-format.png"></button>
        <button type="button" class="btn btn-success" (click)="excelExport()"
          style="margin-top: 30px; margin-left: 10px;"><i class="fa fa-file-excel-o icon-white"
            aria-hidden="true"></i></button>
      </div>
    </section>
    <mat-card-content >
      <ag-grid-angular style="width: 100%; height: 24vw; margin-top: 10px;" class="ag-theme-alpine" [rowData]="rowData"
        [columnDefs]="columnDefs" (gridReady)="onGridReady($event)" [gridOptions]="gridOptions" [pagination]="true"
        [paginationPageSize]="10">
      </ag-grid-angular>
    </mat-card-content>
  </div>